import Image from '@tiptap/extension-image';
import { ReactNodeViewRenderer } from '@tiptap/react';
import ImageNodeView from './ImageNodeView';

export type ImageAlign = 'left' | 'center' | 'right' | 'full';

/** 擴充官方 Image：加 align / caption 屬性與 React NodeView（WordPress 風格圖片編輯）。 */
export const FigureImage = Image.extend({
  name: 'image',
  draggable: true,
  addAttributes() {
    return {
      ...this.parent?.(),
      align: {
        default: 'center',
        parseHTML: (el) => el.getAttribute('data-align') ?? 'center',
        renderHTML: (attrs) => ({ 'data-align': attrs.align as string }),
      },
      caption: {
        default: '',
        parseHTML: (el) => el.getAttribute('data-caption') ?? '',
        renderHTML: (attrs) => ({ 'data-caption': attrs.caption as string }),
      },
      /** 上傳中的暫時佔位（不會存入 R2，前台渲染時忽略）。 */
      uploading: {
        default: false,
        rendered: false,
      },
    };
  },
  /** 序列化為前台 HTML：有圖說時包成 <figure><img><figcaption>。 */
  renderHTML({ node, HTMLAttributes }) {
    const rest = { ...(HTMLAttributes as Record<string, unknown>) };
    delete rest['data-caption'];
    const img: [string, Record<string, unknown>] = ['img', rest];
    const cap = (node.attrs.caption as string) || '';
    if (!cap) return img;
    return ['figure', { 'data-align': node.attrs.align }, img, ['figcaption', {}, cap]];
  },
  addNodeView() {
    return ReactNodeViewRenderer(ImageNodeView);
  },
});
